var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:_vm.cssClass,attrs:{"type":_vm.type,"id":_vm.id},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"blur":_vm.onBlur,"keyup":(event) => this.$emit('keyup', event),"keypress":(event) => this.$emit('keypress', event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }